export enum SiteMode {
  DEFAULT_MODE = 'default',
  RESKIN_MODE = 'reskin',
}
